/* eslint-disable */

/*!
 * @license
 * chartjs-chart-financial
 * http://chartjs.org/
 * Version: 0.1.0
 *
 * Copyright 2020 Chart.js Contributors
 * Released under the MIT license
 * https://github.com/chartjs/chartjs-chart-financial/blob/master/LICENSE.md
 */
!(function(e, t) {
  'object' == typeof exports && 'undefined' != typeof module
    ? t(require('chart.js'))
    : 'function' == typeof define && define.amd
    ? define(['chart.js'], t)
    : t((e = e || self).Chart)
})(this, function(e) {
  'use strict'
  var t = (e = e && e.hasOwnProperty('default') ? e.default : e).helpers,
    a = { position: 'left', ticks: { callback: e.Ticks.formatters.linear } },
    l = e.scaleService.getScaleConstructor('linear').extend({
      _parseValue: function(e) {
        var t, a, l, n
        return (
          void 0 !== e.c
            ? ((t = +this.getRightValue(e.l)),
              (a = +this.getRightValue(e.h)),
              (l = Math.min(t, a)),
              (n = Math.max(t, a)))
            : ((t = void 0),
              (a = e = +this.getRightValue(e.y)),
              (l = e),
              (n = e)),
          { min: l, max: n, start: t, end: a }
        )
      },
      determineDataLimits: function() {
        var e = this,
          a = e.chart,
          l = a.data.datasets,
          n = e.isHorizontal()
        ;(e.min = null),
          (e.max = null),
          t.each(l, function(l, i) {
            var o = a.getDatasetMeta(i)
            a.isDatasetVisible(i) &&
              (function(t) {
                return n ? t.xAxisID === e.id : t.yAxisID === e.id
              })(o) &&
              t.each(l.data, function(t, a) {
                var l = e._parseValue(t)
                isNaN(l.min) ||
                  isNaN(l.max) ||
                  o.data[a].hidden ||
                  ((null === e.min || l.min < e.min) && (e.min = l.min),
                  (null === e.max || e.max < l.max) && (e.max = l.max))
              })
          })
        var i = 0.05 * (e.max - e.min)
        ;(e.min -= i), (e.max += i), this.handleTickRangeOptions()
      }
    })
  e.scaleService.registerScaleType('financialLinear', l, a)
  var n = e.helpers
  e.defaults.financial = {
    label: '',
    hover: { mode: 'label' },
    scales: {
      xAxes: [
        {
          type: 'time',
          distribution: 'series',
          offset: !0,
          ticks: {
            major: { enabled: !0, fontStyle: 'bold' },
            source: 'data',
            maxRotation: 0,
            autoSkip: !0,
            autoSkipPadding: 75,
            sampleSize: 100
          }
        }
      ],
      yAxes: [{ type: 'financialLinear' }]
    },
    tooltips: {
      intersect: !1,
      mode: 'index',
      callbacks: {
        label: function(t, a) {
          var l = a.datasets[t.datasetIndex].data[t.index]
          return n.isNullOrUndef(l.y)
            ? 'O: ' + l.o + '  H: ' + l.h + '  L: ' + l.l + '  C: ' + l.c
            : e.defaults.global.tooltips.callbacks.label(t, a)
        }
      }
    }
  }
  var i = e.controllers.bar.extend({
      dataElementType: e.elements.Financial,
      _updateElementGeometry: function(e, t, a, l) {
        var n = this,
          i = e._model,
          o = n._getValueScale(),
          r = o.getBasePixel(),
          d = o.isHorizontal(),
          s = n._ruler || n.getRuler(),
          c = n.calculateBarValuePixels(n.index, t, l),
          u = n.calculateBarIndexPixels(n.index, t, s, l),
          h = n.chart.data.datasets[n.index].data[t]
        ;(i.horizontal = d),
          (i.base = a ? r : c.base),
          (i.x = d ? (a ? r : c.head) : u.center),
          (i.y = d ? u.center : a ? r : c.head),
          (i.height = d ? u.size : void 0),
          (i.width = d ? void 0 : u.size),
          (i.candleOpen = o.getPixelForValue(Number(h.o))),
          (i.candleHigh = o.getPixelForValue(Number(h.h))),
          (i.candleLow = o.getPixelForValue(Number(h.l))),
          (i.candleClose = o.getPixelForValue(Number(h.c)))
      },
      draw: function() {
        var t,
          a = this.chart.chart.ctx,
          l = this.getMeta().data,
          n = this.getDataset(),
          i = l.length,
          o = 0
        for (e.canvasHelpers.clipArea(a, this.chart.chartArea); o < i; ++o)
          null == (t = n.data[o].o) || isNaN(t) || l[o].draw()
        e.canvasHelpers.unclipArea(a)
      }
    }),
    o = e.helpers
  function r(e) {
    var t,
      a,
      l = e._view,
      n = l.width / 2
    return (
      (t = l.x - n),
      (a = l.x + n),
      { left: t, top: l.candleHigh, right: a, bottom: l.candleLow }
    )
  }
  e.defaults.global.elements.financial = {
    color: {
      up: 'rgba(80, 160, 115, 1)',
      down: 'rgba(215, 85, 65, 1)',
      unchanged: 'rgba(90, 90, 90, 1)'
    }
  }
  var d = e.Element.extend({
      height: function() {
        var e = this._view
        return e.base - e.y
      },
      inRange: function(e, t) {
        var a = !1
        if (this._view) {
          var l = r(this)
          a = e >= l.left && e <= l.right && t >= l.top && t <= l.bottom
        }
        return a
      },
      inLabelRange: function(e, t) {
        if (!this._view) return !1
        var a = r(this)
        return void 0 !== this._view.width
          ? e >= a.left && e <= a.right
          : t >= a.top && t <= a.bottom
      },
      inXRange: function(e) {
        var t = r(this)
        return e >= t.left && e <= t.right
      },
      inYRange: function(e) {
        var t = r(this)
        return e >= t.top && e <= t.bottom
      },
      getCenterPoint: function() {
        var e = this._view
        return { x: e.x, y: (e.candleHigh + e.candleLow) / 2 }
      },
      getArea: function() {
        var e = this._view
        return e.width * Math.abs(e.y - e.base)
      },
      tooltipPosition: function() {
        var e = this._view
        return { x: e.x, y: (e.candleOpen + e.candleClose) / 2 }
      },
      hasValue: function() {
        var e = this._model
        return (
          o.isNumber(e.x) &&
          o.isNumber(e.candleOpen) &&
          o.isNumber(e.candleHigh) &&
          o.isNumber(e.candleLow) &&
          o.isNumber(e.candleClose)
        )
      }
    }),
    s = e.helpers,
    c = e.defaults.global
  c.elements.candlestick = s.merge({}, [
    c.elements.financial,
    { borderColor: c.elements.financial.color.unchanged, borderWidth: 1 }
  ])
  var u = d.extend({
    draw: function() {
      var e,
        t = this._chart.ctx,
        a = this._view,
        l = a.x,
        n = a.candleOpen,
        i = a.candleHigh,
        o = a.candleLow,
        r = a.candleClose,
        d = a.borderColor
      'string' == typeof d && (d = { up: d, down: d, unchanged: d }),
        r < n
          ? ((e = s.getValueOrDefault(
              d ? d.up : void 0,
              c.elements.candlestick.borderColor
            )),
            (t.fillStyle = s.getValueOrDefault(
              a.color ? a.color.up : void 0,
              c.elements.candlestick.color.up
            )))
          : r > n
          ? ((e = s.getValueOrDefault(
              d ? d.down : void 0,
              c.elements.candlestick.borderColor
            )),
            (t.fillStyle = s.getValueOrDefault(
              a.color ? a.color.down : void 0,
              c.elements.candlestick.color.down
            )))
          : ((e = s.getValueOrDefault(
              d ? d.unchanged : void 0,
              c.elements.candlestick.borderColor
            )),
            (t.fillStyle = s.getValueOrDefault(
              a.color ? a.color.unchanged : void 0,
              c.elements.candlestick.color.unchanged
            ))),
        (t.lineWidth = s.getValueOrDefault(
          a.borderWidth,
          c.elements.candlestick.borderWidth
        )),
        (t.strokeStyle = s.getValueOrDefault(
          e,
          c.elements.candlestick.borderColor
        )),
        t.beginPath(),
        t.moveTo(l, i),
        t.lineTo(l, Math.min(n, r)),
        t.moveTo(l, o),
        t.lineTo(l, Math.max(n, r)),
        t.stroke(),
        t.fillRect(l - a.width / 2, r, a.width, n - r),
        t.strokeRect(l - a.width / 2, r, a.width, n - r),
        t.closePath()
    }
  })
  ;(e.defaults.candlestick = e.helpers.merge({}, e.defaults.financial)),
    e.defaults._set('global', {
      datasets: { candlestick: e.defaults.global.datasets.bar }
    })
  e.controllers.candlestick = i.extend({
    dataElementType: u,
    updateElement: function(e, t, a) {
      var l = this,
        n = l.getMeta(),
        i = l.getDataset(),
        o = l._resolveDataElementOptions(e, t)
      ;(e._xScale = l.getScaleForId(n.xAxisID)),
        (e._yScale = l.getScaleForId(n.yAxisID)),
        (e._datasetIndex = l.index),
        (e._index = t),
        (e._model = {
          datasetLabel: i.label || '',
          color: i.color,
          borderColor: i.borderColor,
          borderWidth: i.borderWidth
        }),
        l._updateElementGeometry(e, t, a, o),
        e.pivot()
    }
  })
  var h = e.helpers,
    m = e.defaults.global
  m.elements.ohlc = h.merge({}, [
    m.elements.financial,
    { lineWidth: 2, armLength: null, armLengthRatio: 0.8 }
  ])
  var g = d.extend({
    draw: function() {
      var e = this._chart.ctx,
        t = this._view,
        a = t.x,
        l = t.candleOpen,
        n = t.candleHigh,
        i = t.candleLow,
        o = t.candleClose,
        r = h.getValueOrDefault(t.armLength, m.elements.ohlc.armLength),
        d = h.getValueOrDefault(
          t.armLengthRatio,
          m.elements.ohlc.armLengthRatio
        )
      null === r && (r = t.width * d * 0.5),
        (e.strokeStyle =
          o < l
            ? h.getValueOrDefault(
                t.color ? t.color.up : void 0,
                m.elements.ohlc.color.up
              )
            : o > l
            ? h.getValueOrDefault(
                t.color ? t.color.down : void 0,
                m.elements.ohlc.color.down
              )
            : h.getValueOrDefault(
                t.color ? t.color.unchanged : void 0,
                m.elements.ohlc.color.unchanged
              )),
        (e.lineWidth = h.getValueOrDefault(
          t.lineWidth,
          m.elements.ohlc.lineWidth
        )),
        e.beginPath(),
        e.moveTo(a, n),
        e.lineTo(a, i),
        e.moveTo(a - r, l),
        e.lineTo(a, l),
        e.moveTo(a + r, o),
        e.lineTo(a, o),
        e.stroke()
    }
  })
  ;(e.defaults.ohlc = e.helpers.merge({}, e.defaults.financial)),
    e.defaults._set('global', {
      datasets: { ohlc: { barPercentage: 1, categoryPercentage: 1 } }
    })
  e.controllers.ohlc = i.extend({
    dataElementType: g,
    updateElement: function(e, t, a) {
      var l = this,
        n = l.getMeta(),
        i = l.getDataset(),
        o = l._resolveDataElementOptions(e, t)
      ;(e._xScale = l.getScaleForId(n.xAxisID)),
        (e._yScale = l.getScaleForId(n.yAxisID)),
        (e._datasetIndex = l.index),
        (e._index = t),
        (e._model = {
          datasetLabel: i.label || '',
          lineWidth: i.lineWidth,
          armLength: i.armLength,
          armLengthRatio: i.armLengthRatio,
          color: i.color
        }),
        l._updateElementGeometry(e, t, a, o),
        e.pivot()
    }
  })
})
